import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_rustic_outdoor_porch_decor: FaireThemeEntity = {
  token: "rustic-depot-rustic-outdoor-porch-decor",
  type: "theme",
  retailerToken: "r_464eox2tas",
  name: "Rustic Outdoor & Porch Decor",
  description: "Your farmhouse style for the porch and yard",
  bgColor: "#E0D4C8",
  tileBgColor: "#7e6333",
  productTokens: [
    "p_my63jptwvq",
    "p_ryyxrezupc",
    "p_5vu68sbevx",
    "p_ww5z7d42s9",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
